<template>
  <div id="c-title-bar">
    <div class="title-bar-btns">
      <template v-if="isPreviewCanRun || ip & signBit.run">
        <el-button v-if="isRunning" size="mini" type="danger" @click="stopHandler" :disabled="runDisable">中止</el-button>
        <el-button v-else size="mini" type="success" @click="runHandler" :disabled="runDisable">运行</el-button>
      </template>
      <el-button size="mini" type="success" v-if="isPreviewCanTest || ip & signBit.test" @click="testHandler" :disabled="isTesting">测试</el-button>
<!--      <el-button size="mini" type="primary" v-if="ip & signBit.save" @click="saveHandler">保存-提交</el-button>-->
      <el-button size="mini" type="primary" v-if="isEdit" :disabled="saveDisable" @click="commitCheckBlank(false)">保存</el-button>
    </div>
    <el-dropdown v-if="ip & signBit.answers && answerList && answerList.length" @command="handleTestList">
      <el-button size="mini" type="primary">
        测试记录<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="item in answerList"
                          :command="item"
                          :key="item.UpdatedTime">{{getTestItemLabel(item)}}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script type="text/babel">
  import { mapGetters } from 'vuex';
  import iframe from '../../scripts/iframe/index'
  import Socket from '../../scripts/socket/index'
  import { emitEvent } from '../../utils/eventBus/vueEvent'
  import Events from '../../scripts/events/index'
  import Env from '../../scripts/common/env'
  import consoleStyle from './consoleStyle'
  import Question from '../../scripts/common/question'
  import lang from "../../scripts/common/language";
  import aegis from '../../scripts/aegis'
  import timer from '../../scripts/timer'
  import HttpRunner from '../../scripts/http-runner';

  export default {
    name: 'c-title-bar',
    data() {
      return {
        ip: Env.signBit.getQueryIp(this.$route.query),
        runDisable: false,
        saveDisable: false,
        isPreviewCanRun: true, // 预览模式可以运行&测试;
      }
    },
    computed: {
      ...mapGetters(['answerList', 'isRunning', 'isTesting', 'runningData', 'language',
        'isRunLocal', 'isEdit', 'ideCode', 'isLocalIde', 'skulptReady']),
      signBit() {
        return Env.signBit;
      },
      isPreviewCanTest() {
        return this.language.value !== lang.py.value
      }
    },
    created() {
    },
    methods: {
      runHandler() {
        if (!this.isRunning) {
          this.$store.dispatch('setRunningData', { sessionId: '' });
          timer.setTimer(this.checkRunResCb, timer.timers.run.time, timer.timers.run.key);
          this.setRunDisable()
          emitEvent(Events.OUTPUT_CONSOLE, { resort: true, result: consoleStyle.getRun('开始运行...') })
          this.$store.dispatch('setIsRunning', true);
          console.log('-runCode-start time:', performance.now(), this.isRunning);
          if (this.isEdit) {
            iframe.getIdeCode(iframe.TYPE_RUN, this.isLocalIde);
          } else {
            emitEvent(Events.YOUTH_SET_CODE, { type: iframe.TYPE_RUN, data: this.ideCode });
          }
        } else {
          console.error('runHandler isRunning = true');
        }
      },

      checkRunResCb() {
        if (this.isRunLocal) {
          console.error('iframe python runres error')
          aegis.report('iframe python runres error');
          if (this.skulptReady) {
            emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr('python回调超时，请检查代码是否有无限循环；或重试运行') })
            emitEvent(Events.RUN_PYTHON_CODE_LOCAL, 'print("停止运行")', true, true);
            this.$store.dispatch('setIsRunning', false)
          } else {
            emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr('python回调超时，请尝试关闭编程ide重新进入；或向老师反馈问题') })
          }
        } else {
          console.warn(`programGate runres error: ${this.language.label}`)
          aegis.report(`programGate runres error: ${this.language.label}`);
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getErr(`${this.language.label}程序启动超时，请重试`) })
          if (!HttpRunner.isHttp()) {
            HttpRunner.init(null, true);
          }
          this.stopHandler();
        }
      },

      testHandler() {
        if (!this.isTesting) {
          timer.clearTimer(timer.timers.testGetEnd.key); // 备用清理
          timer.setTimer(this.checktestResCb, timer.timers.test.time, timer.timers.test.key);
          emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getTest('开始测试...') })
          this.$store.dispatch('setIsTesting', true);
          console.log('- test Code-start time:', performance.now(), this.isTesting);
          if (this.isEdit) {
            iframe.getIdeCode(iframe.TYPE_TEST, this.isLocalIde);
            // iframe.getIdeCode(iframe.TYPE_TEST_HTTP, this.isLocalIde);
          } else {
            Events.emitIframeEvent({ method: iframe.YOUTH_SET_CODE, type: iframe.TYPE_TEST, data: this.ideCode })
          }
        } else {
          console.error('testHandler isTesting = true');
        }
      },

      checktestResCb() {
        console.warn('onlineJudge testres timeout')
        aegis.report('onlineJudge testres timeout')
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getWarn('测试程序启动超时，请重试') })

        // 发起cgi请求，进行测试；
        // iframe.getIdeCode(iframe.TYPE_TEST_HTTP, this.isLocalIde);
        emitEvent(Events.TEST_CODE_RES, { Code: 400, Msg: '测试程序启动超时' })
        timer.clearTimer(timer.timers.testGetEnd.key); // 备用清理
      },

      saveHandler() {
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getSave('保存...') })
        iframe.getIdeCode(iframe.TYPE_SAVE, this.isLocalIde);
      },

      commitHandler(isConfirm, isBlank) {
        if (this.saveDisable) {
          return;
        }
        if (!isBlank && this.language.value !== lang.py.value && (!this.answerList || !this.answerList.length)) {
          if (!isConfirm) {
            // 提交
            this.$confirm('代码未进行过测试，确认直接保存吗？', '温馨提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '确认',
              cancelButtonText: '取消'
            }).then(() => {
              this.commitHandler(true)
            })
            return;
          }
        }
        this.setSaveDisable();
        // 提交
        emitEvent(Events.OUTPUT_CONSOLE, { result: consoleStyle.getCommit('保存本题...') })
        iframe.getIdeCode(iframe.TYPE_COMMIT, this.isLocalIde);
      },

      commitCheckBlank(isConfirm) {
        if (!this.ideCode || !(this.ideCode.trim())) {
          if (!isConfirm) {
            // 提交
            this.$confirm('代码为空，确认保存吗？', '温馨提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '确认',
              cancelButtonText: '取消'
            }).then(() => {
              this.commitCheckBlank(true)
            })
            return;
          }
          this.commitHandler(false, true)
        } else {
          this.commitHandler(false)
        }
      },

      setSaveDisable() {
        this.saveDisable = true;
        setTimeout(() => {
          this.saveDisable = false;
        }, 5000);
      },

      setRunDisable() {
        this.runDisable = true;
        setTimeout(() => {
          this.runDisable = false;
        }, 2000);
      },

      stopHandler() {
        if (this.isRunning) {
          this.setRunDisable()
          if (this.isRunLocal) {
            emitEvent(Events.RUN_PYTHON_CODE_LOCAL, 'print("停止运行")', true);
            this.$store.dispatch('setIsRunning', false)
          } else if (this.runningData.sessionId) {
            // console.log('-stopCode-start time:', performance.now());
            // console.log('-stopCode-start runningData:', this.runningData);
            if (HttpRunner.isHttp()) {
              HttpRunner.stop(this.runningData, this.$route.query);
            } else {
              Socket.stopCode(this.runningData, this.$route.query);
            }
            timer.setTimer(this.checkStopResCb, timer.timers.stop.time, timer.timers.stop.key);
          } else {
            emitEvent(Events.RUN_CODE_STOP_RES, {
              Code: 400,
              Msg: 'sessionId is null'
            })
          }
          timer.clearTimer(timer.timers.run.key);
          timer.clearTimer(timer.timers.getOutput.key);
        }
      },

      checkStopResCb() {
        console.warn('programGate stop timeOut')
        aegis.report('programGate stop timeOut')
        emitEvent(Events.OUTPUT_CONSOLE, consoleStyle.getWarn('停止操作超时'))
        this.$store.dispatch('setIsRunning', false)
      },

      getTestItemLabel(item) {
        const time = new Date(item.UpdatedTime * 1000).toLocaleString()
        const status = Question.testStatus[item.Status] && Question.testStatus[item.Status].label || '测试异常'
        return `${time} [${status}]`
      },
      handleTestList(item, ctx, isConfirm) {
        if (!isConfirm) {
          this.$confirm(`要将编辑区的代码切换成测试记录:"${this.getTestItemLabel(item)}"的代码？`, '温馨提示', {
            distinguishCancelAndClose: true,
            confirmButtonText: '确认',
            cancelButtonText: '取消'
          }).then(() => {
            this.handleTestList(item, ctx, true)
          })
          return;
        }
        // this.$message.success('代码切换成功：' + this.getTestItemLabel(item));
        this.$store.dispatch('getTestCodeInfo', { message:  this.getTestItemLabel(item), test: item })
      },
    }
  }
</script>

<style lang="scss">

  @import "../../assets/scss/base/variables.scss";

  #c-title-bar {
    height: 45px;
    flex-grow: 0;
    background-color: #ddd;
    border-bottom: 1px solid #b4b4b4;
    display: flex;
    justify-content: space-between;
    padding: 8px 10px 0 10px;
  }
</style>
